import {Component, OnInit} from '@angular/core';
import {BaseListComponent} from "../base-list/base-list.component";
import {NgIf} from "@angular/common";
import {TemplateComponent} from "../template/template.component";
import {ActivatedRoute, Router} from "@angular/router";
import {CrudService} from "../service/crud.service";
import {BaseEditComponent} from "../base-edit/base-edit.component";
import {EInputType, IEditConfig} from "../../../interface/table.config";
import {ICrudRes} from "../../../interface/http.config";
import {Validators} from "@angular/forms";

@Component({
  selector: 'app-link-edit',
  standalone: true,
  imports: [
    BaseListComponent,
    NgIf,
    TemplateComponent,
    BaseEditComponent
  ],
  templateUrl: './link-edit.component.html',
  styleUrl: './link-edit.component.scss'
})
export class LinkEditComponent implements OnInit {
  data: ICrudRes;
  id: string | null = null;

  constructor(protected router: Router,
              protected route: ActivatedRoute,
              protected crudService: CrudService) {

  }

  editLink = '/dashboard/link-edit/';
  menuLink = '/dashboard/link';
  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id') || null;

    this.crudService.provider = 'link';

    if (this.editConfig.groups.length && this.id) {

      this.editConfig.groups[0].configs = [
        {
          field: 'id',
          type: EInputType.DISABLED,
          name: 'Id',
          validators: [],
        },
        ...this.editConfig.groups[0].configs
      ];

      this.getItem();
    } else {
      this.data = {
        settings: {},
      } as any;
    }
  }

  editConfig: IEditConfig = {
    groups: [
      {
        name: 'General (New link)',
        configs: [
          {field: 'order', name: 'Order (numeric)', type: EInputType.NUMBER, validators: [Validators.required, Validators.pattern(/\d+/)]},
          {field: 'column', name: 'Column (1-3)', type: EInputType.NUMBER, validators: [Validators.required, Validators.pattern(/\d+/)]},
          {field: 'href', name: 'Href', type: EInputType.TEXT, validators: []},
          {field: 'title_en', name: 'En', type: EInputType.TEXT, validators: []},
          {field: 'title_es', name: 'Es', type: EInputType.TEXT, validators: []},
        ]
      }
    ]
  };

  getItem() {
    this.crudService.item({id: this.id}).then(item => {
      this.data = item;

      this.editConfig.groups[0].name = 'General (link ' + item.name + ')';
    }).catch(console.error);
  }

  onAction(actionName: string, item: any) {
    if (actionName === 'submit') {
      this.crudService.save(item).then((data) => {
        if (!item.id) {
          this.router.navigate([this.editLink + '/' + data.document.id]).catch(console.error);
        } else {
          this.getItem();
        }
      });
    }

    if (actionName === 'back') {
      this.router.navigate([this.menuLink]).catch(console.error);
    }
  }
}
